import EFOcats_validate_required from './efocats_validate_required.js';
import EFOcats_validate_limit from './efocats_validate_limit.js';
import EFOcats_validate_text from './efocats_validate_text.js';
import EFOcats_validate_tel from './efocats_validate_tel.js';
import EFOcats_validate_email from './efocats_validate_email.js';
import EFOcats_validate_checkbox from './efocats_validate_checkbox.js';
import EFOcats_validate_radio from './efocats_validate_radio.js';
import EFOcats_validate_url from './efocats_validate_url.js';
import EFOcats_validate_file from './efocats_validate_file.js';
import EFOcats_validate_birthday from './efocats_validate_birthday.js';
import EFOcats_validate_compare from './efocats_validate_compare.js';
import EFOcats_validate_password from './efocats_validate_password.js';

/**
 * エラーチェッククラス
 */
export default class EFOcats_validates {
  constructor() {
    this.required = new EFOcats_validate_required();
    this.limit = new EFOcats_validate_limit();
    this.text = new EFOcats_validate_text();
    this.tel = new EFOcats_validate_tel();
    this.email = new EFOcats_validate_email();
    this.checkbox = new EFOcats_validate_checkbox();
    this.radio = new EFOcats_validate_radio();
    this.url = new EFOcats_validate_url();
    this.file = new EFOcats_validate_file();
    this.birthday = new EFOcats_validate_birthday();
    this.compare = new EFOcats_validate_compare();
    this.password = new EFOcats_validate_password();
  }

  /**
   * 使用するバリデーションを設定する
   * @param {*} elem チェック対象の入力欄
   */
  set_validateList(elem) {
    const validateList = [];

    // タグ名とtype属性によるバリデーション
    validateList.push(elem.attr('type'));
    validateList.push(elem.prop('tagName'));

    // 必須
    if (elem.parents().hasClass('required')) {
      validateList.push('required');
    }

    // 文字数制限
    if (elem.attr('data-minlength') || elem.attr('data-maxlength')) {
      validateList.push('limit');
    }

    // 個別カスタマイズ
    if (elem.attr('validate-type')) {
      const validatetypes = elem.attr('validate-type').split(',');

      validatetypes.forEach(validatetype => {
        validateList.push(validatetype.trim());
      });
    }

    return validateList;
  }

  /**
   * エラーチェック
   * @param {*} elem チェック対象の入力欄
   */
  check_error(elem) {
    let status_data = {status: 'success'};
    const validateList = this.set_validateList(elem);

    // エラーチェック
    for (let validateIndex = 0; validateIndex < validateList.length; validateIndex++) {
      const validate_id = validateList[validateIndex];
      if (this[validate_id]) {
        status_data = this[validate_id].validate(elem);
        if (status_data.status === 'error') {
          break;
        }
      }
    }

    if (status_data.status === 'success') {
      elem.removeClass('error-modifer');
      elem.parents('.check-flag').addClass('ok-flag');
      elem.parents('.check-flag').addClass('icon-flag');
      elem.parents('.message-flag').attr('data-error-text', '');

      const check_flag = elem.parents('.qa').find('.check-flag').length;
      const ok_flag = elem.parents('.qa').find('.ok-flag').length;

      if (check_flag === ok_flag) {
        elem.parents('.qa').addClass('go-flag');
      } else {
        elem.parents('.qa').removeClass('go-flag');
      }

      if (status_data.required === 'non-required') {
        elem.parents('.check-flag').addClass('ok-flag').removeClass('icon-flag');
      }
    } else {
      // エラー処理
      elem.parents('.qa').removeClass('go-flag');
      elem.addClass('error-modifer');
      elem.parents('.check-flag').removeClass('ok-flag');
      elem.parents('.check-flag').removeClass('icon-flag');

      // エラーテキスト表示
      elem.parents('.message-flag').attr('data-error-text', status_data.message);

      // 分析データ
      efocats.submit.error(status_data, elem);
    }

    if (status_data.status === 'error') {
      elem.parents('section').addClass('checked');
    }

    return status_data;
  }
}
